export function OutlineDashboardIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.5 10C8.433 10 10 8.433 10 6.5C10 4.567 8.433 3 6.5 3C4.567 3 3 4.567 3 6.5C3 8.433 4.567 10 6.5 10Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path d="M13 3H22" stroke={stroke} strokeWidth={strokeWidth} strokeMiterlimit="10" />
      <path d="M13 6.38086H22" stroke={stroke} strokeWidth={strokeWidth} strokeMiterlimit="10" />
      <path d="M13 9.75H22" stroke={stroke} strokeWidth={strokeWidth} strokeMiterlimit="10" />
      <path d="M3 19.75V22" stroke={stroke} strokeWidth={strokeWidth} strokeMiterlimit="10" />
      <path
        d="M6.37012 16.3691V21.9991"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path d="M9.75 13V22" stroke={stroke} strokeWidth={strokeWidth} strokeMiterlimit="10" />
      <path
        d="M17.5 14.3398L14 16.8898L15.34 20.9998H19.66L21 16.8898L17.5 14.3398Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </svg>
  );
}
